import * as tslib_1 from "tslib";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { AppModule } from "@/store/modules/app";
import UEditor from "@/components/UEditor/index.vue";
import service from "@/api/request";
import { getExamDetail } from "@/api/exam";
let ExamInfo = class ExamInfo extends Vue {
    constructor() {
        super(...arguments);
        this.ueConfig = {
            toolbars: [['undo', 'redo', '|', 'fontsize', 'forecolor', 'backcolor', 'bold', 'italic', 'underline', '|', 'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', 'lineheight', '|', 'directionalityltr', 'directionalityrtl', 'indent', '|', 'simpleupload', '|', 'fullscreen' //全屏
                ]],
            initialFrameWidth: 700,
            initialFrameHeight: 320,
            autoHeightEnabled: false
        };
        this.name = ''; // 试卷名称
        this.detail = ''; // 存储编辑器的值 TODO
        this.defaultMsg = ''; // 编辑时传入编辑器
        this.paperId = ''; // 为第二步预加载
        this.imgLoading = false;
        this.imgUrl = ''; // 封面图
        this.checkInfoFlag = false; //是否有未通过的校验条件
        this.btnLock = false; //防止用户多次点击下一步
    }
    get isSidebarExpanded() {
        return AppModule.sidebar.opened;
    }
    handleExamInfoChange(examId) {
        this.loadExamInfo(this.examInfo);
    }
    async loadExamInfo(examinfo) {
        if (examinfo) {
            this.name = examinfo.name;
            this.imgUrl = examinfo.imgUrl;
            this.detail = examinfo.detail || '';
            this.defaultMsg = examinfo.detail || '';
            this.examEditor && this.examEditor.setContent(this.detail);
        }
        if (this.examId === '')
            return;
        this.$emit('loading', true);
        try {
            const res = await getExamDetail(this.examId);
            const data = res.data.data;
            this.name = data.name;
            this.imgUrl = data.imgUrl;
            this.detail = data.detail || '';
            this.defaultMsg = data.detail || '';
            this.paperId = data.paperId;
            this.examEditor && this.examEditor.setContent(this.detail);
        }
        catch (_) { }
        finally {
            this.$emit('loading', false);
        }
    }
    cancel() {
        this.$router.push({
            name: 'Examination'
        });
    }
    next() {
        this.checkExamInfo();
        if (this.checkInfoFlag) {
            return;
        }
        this.btnLock = true;
        const data = {
            name: this.name,
            imgUrl: this.imgUrl,
            detail: this.detail,
        };
        if (this.paperId)
            data.paperId = this.paperId;
        this.$emit('update-exam-info', data, 1);
        this.$emit('go-page-two');
        this.btnLock = false;
    }
    setDetail(content) {
        this.detail = content;
    }
    // 检测考试信息
    checkExamInfo() {
        let tip = '';
        if (!this.name) {
            tip = '请输入考试名称';
        }
        else if (this.imgLoading) {
            tip = '封面图正在上传中请稍后';
        }
        else if (!this.imgUrl) {
            tip = '请上传考试封面图';
        }
        if (tip) {
            this.checkInfoFlag = true;
            this.$message.warning(tip);
        }
        else {
            this.checkInfoFlag = false;
        }
    }
    // 上传封面图
    changeCover(event) {
        const el = event.target;
        const file = el.files[0];
        if (!['image/png', 'image/jpeg', 'image/jpg'].includes(file.type)) {
            return this.$message.error('仅支持jpg、png、jpeg格式');
        }
        this.imgLoading = true;
        service.postByForm('/courseAdmin/file/uploadFile', {
            uploadFile: file,
            businessType: 'exam',
            fileType: 'examCover'
        }).then(res => {
            this.imgUrl = res.data.data || '';
        }).finally(() => {
            this.imgLoading = false;
        });
    }
};
tslib_1.__decorate([
    Prop({ type: String, default: '' })
], ExamInfo.prototype, "examId", void 0);
tslib_1.__decorate([
    Prop({ type: Object })
], ExamInfo.prototype, "examInfo", void 0);
tslib_1.__decorate([
    Ref()
], ExamInfo.prototype, "examEditor", void 0);
tslib_1.__decorate([
    Watch('examId', { immediate: true })
], ExamInfo.prototype, "handleExamInfoChange", null);
ExamInfo = tslib_1.__decorate([
    Component({
        name: 'ExamInfo',
        components: {
            Editor: UEditor
        }
    })
], ExamInfo);
export default ExamInfo;
